/** @tossdocs-ignore */
var SPEED_DEFAULT = 1;

export { SPEED_DEFAULT };
